import * as React from 'react';

import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface ReloadButtonProps {

}

export const ReloadButton: React.FC<ReloadButtonProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Button
            icon={<ReloadOutlined />}
            style={{ width: '100%' }}
            onClick={() => window.location.reload()}
        >
            {t('Common.reload')}
        </Button>
    );
};